import ClientsContainer from './containers/ClientsContainer.jsx'

// Sync route definition
export default {
  path      : '/client-versions',
  component : ClientsContainer
}



// WEBPACK FOOTER //
// ./src/routes/Clients/index.jsx